/**
 * Temporary solution to show errors.
 */
export function showError(message: string): void {
  alert(message);
}
